import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../common/reducers/initContext";
import { dataHookFactory } from "../common/reducers/utilities";
import { ensureArray } from "../common/utils/arrayUtilities";

const compareOverlays = (o1, o2) => o1.id === o2.id;

const mapOverlaysSlice = createSlice({
    name: 'mapOverlays',
    initialState: {
        data: []
    },
    reducers: {
        set: (state, action) => {
            state.data = action.payload;
        },
        addOrUpdate: (state, action) => {
            for (const result of ensureArray(action.payload)) {
                let idx = state.data.findIndex(r => compareOverlays(r, result));
                if (idx >= 0) {
                    state.data.splice(idx, 1, result);
                } else {
                    state.data.push(result);
                }
            }
        },
        remove: (state, action) => {
            for (const result of ensureArray(action.payload)) {
                let idx = state.data.findIndex(r => compareOverlays(r, result));
                if (idx >= 0) {
                    state.data.splice(idx, 1);
                }
            }
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => mapOverlaysSlice.getInitialState());
    }
});

// #region network operations
const fetchMapOverlays = network => {};
export const createMapOverlay = (network, overlay) => network.post('/api/v1/mapoverlays', overlay, mapOverlaysSlice.actions.addOrUpdate);
export const updateMapOverlay = (network, overlay) => network.put('/api/v1/mapoverlays', overlay, mapOverlaysSlice.actions.addOrUpdate);
export const removeMapOverlay = (network, overlay) => network.delete('/api/v1/mapoverlays/' + encodeURIComponent(overlay.id), mapOverlaysSlice.actions.remove);
// #endregion

// #region permisison checks
export const canAddOverlay = (credentials, overlay) => credentials.access.hasFull('administrator');
export const canUpdateOverlay = canAddOverlay;
export const canRemoveOverlay = canAddOverlay;
// #endregion

// #region selectors
const selectAllOverlays = state => state.mapOverlays.data;
// #endregion

// #region listeners
const listen = {
    overlayCreated: (overlay, { dispatch }) => dispatch(mapOverlaysSlice.actions.addOrUpdate(overlay)),
    overlayUpdated: (overlay, { dispatch }) => dispatch(mapOverlaysSlice.actions.addOrUpdate(overlay)),
    overlayRemoved: (overlay, { dispatch }) => dispatch(mapOverlaysSlice.actions.remove(overlay))
}
// #endregion

export const [useMapOverlays] = dataHookFactory(selectAllOverlays, { run: fetchMapOverlays, listen });

const reducerDetails = { name: mapOverlaysSlice.name, reducer: mapOverlaysSlice.reducer };
export default reducerDetails;